import React from 'react'
import getConfig from 'next/config'
import { makeStyles } from '@material-ui/core/styles'
import messages from '@utils/messages'
import { List, ListItem, Theme, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import ResponsiveModal from '@src/components/ResponsiveModal'
import LanguageCustomRadio from './CountryAndLanguageMenu/LanguageCustomRadio'

const {
  publicRuntimeConfig: { supportedLanguageLabels },
} = getConfig()

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  list: {
    padding: 0,
  },
  listItem: {
    padding: 0,
    '& > span': {
      fontSize: theme.typography.pxToRem(16),
    },
  },
}))

interface Props {
  languages: string[]
  currentLanguage: string
  onLanguageSelect: (selectedLanguage: string) => void
  isOpen: boolean
  onClose: React.Dispatch<React.SetStateAction<boolean>>
}

const MobileLanguageSelectModal: React.FC<Props> = ({
  languages,
  currentLanguage,
  onLanguageSelect,
  isOpen,
  onClose,
}) => {
  const classes = useStyles()
  const onCloseModal = () => {
    onClose(false)
  }

  return (
    <ResponsiveModal
      open={isOpen}
      onClose={onCloseModal}
      renderTitle={() => (
        <Typography component="h2" variant="h2">
          <FormattedMessage {...messages.CHANGE_LANGUAGE} />
        </Typography>
      )}
    >
      <div className={classes.root}>
        <List className={classes.list}>
          {languages.map((languageKey, index) => {
            return (
              <ListItem
                className={classes.listItem}
                key={index}
                onClick={() => onLanguageSelect(languageKey)}
              >
                <LanguageCustomRadio
                  checked={languageKey === currentLanguage}
                />
                {supportedLanguageLabels[languageKey.toUpperCase()]}
              </ListItem>
            )
          })}
        </List>
      </div>
    </ResponsiveModal>
  )
}

export default MobileLanguageSelectModal
